// components/filters/TotalOOFilter.js
import React from "react";
import FilterBase from "../FilterBase";
import Input from "../../ui/Input";
import Space from "../../ui/Space";
import { FILTER } from "../../utils/Struct";
import Button from "../../ui/Button";
import Label from "../../ui/Label";
import { ENUMS } from "../../utils/Enums";
import { showCategorySelector } from "../../utils/Utils";

export default function GenericSingleValue(props) {

    const { onSave = () => { }, onClose = () => { }, filter = {}, inputParams = {}, edit = false, category = false, subcategory = false } = props;

    const { value = 1, type = "" } = filter;

    let text = filter.text;
    let text2 = filter.text2;
    let instructions = filter.instructions;
    let _data = ENUMS.REPORT_FILTERS.find(item => item.value === type) || false;

    if (_data) {
        text = _data.text;
    }


    const fields = [
        { key: "value_1", value: (edit) ? filter.value_1 : "", help: (category || subcategory) ? "Enter a value or PgUp to select" : "Enter a value." },
        { label: "save", key: "save", value: "", help: "Press Enter to save" },
    ];

    const save = (tabs) => {
        const value_1 = tabs.find(f => f.key === "value_1").value;
        const _f = {
            ...FILTER,
            type: value,
            value_1: value_1.toString()
        }
        onSave(_f, filter);
    }

    const drawCategorySelect = (update, setIndex) => {

        if (!category && !subcategory) {
            return;
        }
        setIndex("save");
        showCategorySelector({
            callback: (e) => {
                if (e) {
                    if (category && !subcategory) {
                        update("value_1", e.category_1)
                    }
                    if (!category && subcategory) {
                        update("value_1", e.category_2)
                    }
                    if (category && subcategory) {
                        if (e.category_2) {
                            update("value_1", e.category_1 + " - " + e.category_2)
                        } else {
                            update("value_1", e.category_1)
                        }
                    }
                }
                setIndex("value_1")
            }
        })
    }

    return (
        <FilterBase fields={fields} onClose={() => onClose()} onSave={(tabs) => {
            save(tabs, filter)
        }}>
            {({ editProps, update, tabs, proceed, setIndex }) => (
                <div>
                    <Space>
                        <span>{text}</span>

                        <Input onPageUp={() => drawCategorySelect(update, setIndex)} doubleclick={() => drawCategorySelect(update, setIndex)} {...editProps("value_1")} {...inputParams} onFill={(e) => proceed(e)} />
                        {(text2 && <span>{text2}</span>)}
                        <Button onClick={() => save(tabs)} {...editProps("save")}>Save</Button>
                    </Space>
                    {(instructions && <Label style={{ "textAlign": "left" }}>{instructions}</Label>)}
                </div>
            )}
        </FilterBase>
    );
}
